module.exports = __webpack_public_path__ + "img/image_merchantside@3x.27688679.png";